@if (reply.reminder) {
    <div class="reminder-alert">
        <app-reply-reminder-alert
            [reminder]="reply.reminder"
            (removeReminderClick)="onRemoveReminderClick()"></app-reply-reminder-alert>
    </div>
}
<div
    class="select-block"
    [class.is-selectable]="isSelectable()"
    (click)="selectReply($event, reply, isSelectable(), true)">
    <sb-user-avatar
        (click)="rightPanelService.open(rightPanelTypeEnum.user, { user: reply.author })"
        [ngClass]="{ 'user-avatar-xs': isSubReply, 'user-avatar-sm': !isSubReply, transparent: reply.isHidden }"
        class="pointer"
        [user]="reply.author"
        [size]="isSubReply ? 'extra-small' : 'small'"
        [isNeedTooltip]="false"
        [withLabel]="true">
    </sb-user-avatar>

    <div style="flex-basis: 100%">
        <div class="position-relative" id="reply-id-{{ reply.id }}">
            @if (!commonDataService.isOneTime && reply.noteIds.length) {
                <app-note-link-line class="reference-line" [noteIds]="reply.noteIds" [ticket]="ticket">
                </app-note-link-line>
            }

            <div
                class="social-reply-text-container d-inline-block position-relative"
                [ngClass]="{
                    'full-width': reply.editingReply,
                    transparent: reply.isHidden,
                }">
                @if (!reply.editingReply) {
                    <div
                        class="social-reply-text"
                        [ngClass]="{
                            'social-reply-text-contains-bad-words': reply.containsBadWords,
                            'social-reply-text-transparent': reply.isTransparent,
                            'social-reply-text-with-handling': isHandlingAvailable && !reply.isDeleted,
                            'social-reply-text-handled': isHandlingAvailable && reply.handledBy,
                        }">
                        <a (click)="rightPanelService.open(rightPanelTypeEnum.user, { user: reply.author })">
                            {{ reply.author.name || reply.author.email }}
                            @if (reply.author.socialMediaAccountInfo?.accountName) {
                                <span>&nbsp; ({{ reply.author.socialMediaAccountInfo?.accountName }})</span>
                            }
                        </a>
                        <br />
                        @if (ticket.constraints.isReplyingToEnabled && reply.mentionedUsers.length) {
                            <div class="mb-2 text-light">
                                {{ 'Replying to' | translate }}
                                @for (mentionedUser of reply.mentionedUsers; track mentionedUser; let isLast = $last) {
                                    <span>
                                        &#64;{{ mentionedUser }}&nbsp;
                                        @if (!isLast) {
                                            {{ 'and' | translate }}
                                        }
                                    </span>
                                }
                            </div>
                        }

                        @if (!reply.isDeleted) {
                            <app-highlight-reply-mention
                                class="notification-list-item-text"
                                [message]="reply.message.text | encodeHtmlSymbols"
                                [mentionedUsers]="ticket.facebookUsersToMention">
                            </app-highlight-reply-mention>
                            @if (reply.isEdited) {
                                <small class="text-light"> ({{ 'edited' | translate }})</small>
                            }
                            @if (reply.isAutoHidden) {
                                <small class="text-light"> ({{ 'autohidden' | translate }})</small>
                            }
                        } @else {
                            <small class="text-light">{{ 'This message was deleted.' | translate }}</small>
                        }
                        @if (isHandlingAvailable && !reply.isDeleted) {
                            <button
                                class="btn btn-icon btn-transparent align-top"
                                type="button"
                                [tooltip]="handledByTooltip"
                                [disabled]="isHandling"
                                container="body"
                                [adaptivePosition]="false"
                                (click)="handle()">
                                <sb-inline-svg
                                    [ngClass]="{ 'icon-handled': reply.handledBy }"
                                    class="icon"
                                    aria-label="My icon"
                                    [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Check icon.svg'">
                                </sb-inline-svg>
                            </button>
                        }
                    </div>
                } @else {
                    <div>
                        <app-edit-reply-social-media
                            [replyModel]="reply"
                            [ticket]="ticket"
                            [parent]="parent"
                            [reply]="reply"
                            [parentReply]="parentReply">
                        </app-edit-reply-social-media>
                    </div>
                }
                @if (!commonDataService.user.isReadOnly) {
                    <div class="reply-menu">
                        <div dropdown container="#thread-container-replies" [dropup]="isReplyMenuDropUp">
                            <div
                                [tooltip]="'Copied' | translate"
                                placement="bottom"
                                #copiedTooltip="bs-tooltip"
                                [tooltipFadeDuration]="1000"
                                [triggers]="''"
                                container="body">
                                <button
                                    #replyMenuBtn
                                    class="btn btn-icon btn-transparent"
                                    dropdownToggle
                                    type="button"
                                    aria-controls="dropdown-basic">
                                    <sb-inline-svg
                                        class="icon"
                                        aria-label="My icon"
                                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/More icon.svg'">
                                    </sb-inline-svg>
                                </button>
                            </div>

                            <ul
                                id="dropdown-basic"
                                *dropdownMenu
                                class="dropdown-menu"
                                role="menu"
                                aria-labelledby="button-basic">
                                @if (!commonDataService.isOneTime && !reply.isDraft) {
                                    <li role="menuitem">
                                        <button
                                            class="dropdown-item"
                                            type="button"
                                            (click)="parent.openNoteEditor(reply)"
                                            translate>
                                            Add note
                                        </button>
                                    </li>
                                    <li role="menuitem">
                                        <button
                                            class="dropdown-item"
                                            type="button"
                                            (click)="parent.openAddTagsModal(reply)"
                                            translate>
                                            Add tags
                                        </button>
                                    </li>
                                }
                                @if (!reply.isDeleted) {
                                    @if (
                                        ticket.isEditable &&
                                        !reply.isDraft &&
                                        (ticket.constraints.isBulkReplyDeletionAllowed ||
                                            ticket.constraints.isBulkReplyHidingAllowed)
                                    ) {
                                        <li role="menuitem">
                                            <button
                                                class="dropdown-item"
                                                type="button"
                                                (click)="selectReply($event, reply)"
                                                translate>
                                                Select
                                            </button>
                                        </li>
                                    }
                                    @if (!commonDataService.isOneTime && !reply.isDraft) {
                                        @if (
                                            isInboxElementVisible(
                                                commonDataService.customerSettings?.inboxElementsVisibility
                                                    ?.ticketHeader?.forwardAction
                                            )
                                        ) {
                                            <li role="menuitem">
                                                <button
                                                    class="dropdown-item"
                                                    data-testid="forward-message-action"
                                                    type="button"
                                                    (click)="
                                                        forwardMessageService.openForwardForm(
                                                            reply,
                                                            forwardEntityTypeEnum.reply,
                                                            ticket
                                                        )
                                                    "
                                                    translate>
                                                    Forward message
                                                </button>
                                            </li>
                                        }
                                    }
                                    @if (reply.isByTeam && ticket.isReplyCanBeEdited && !reply.isDraft) {
                                        <li role="menuitem">
                                            <button
                                                class="dropdown-item"
                                                type="button"
                                                (click)="showEditReply(reply)"
                                                translate>
                                                Edit
                                            </button>
                                        </li>
                                    }
                                    @if (
                                        (reply.isByTeam || ticket.constraints.isCustomerReplyDeletionAllowed) &&
                                        ticket.constraints.isReplyDeletionAllowed &&
                                        ticket.isEditable
                                    ) {
                                        <li role="menuitem">
                                            <button
                                                class="dropdown-item"
                                                type="button"
                                                (click)="openDeleteReplyModal()"
                                                translate>
                                                Delete
                                            </button>
                                        </li>
                                    }
                                    @if (isHidingAvailable) {
                                        <li role="menuitem">
                                            @if (!reply.isHidden) {
                                                <button
                                                    class="dropdown-item"
                                                    type="button"
                                                    (click)="openHideReplyModal()"
                                                    translate>
                                                    Hide
                                                </button>
                                            }
                                            @if (reply.isHidden && !reply.isDraft) {
                                                <button
                                                    class="dropdown-item"
                                                    type="button"
                                                    (click)="openShowReplyModal()"
                                                    translate>
                                                    Show
                                                </button>
                                            }
                                        </li>
                                    }
                                    @if (reply.id) {
                                        <li role="menuitem">
                                            <button
                                                type="button"
                                                class="dropdown-item"
                                                ngxClipboard
                                                [cbContent]="replyUrl"
                                                (click)="copiedTooltip.show(); copiedTooltip.hide()"
                                                translate>
                                                Copy link
                                            </button>
                                        </li>
                                    }
                                }
                                @if (!reply.isDeleted) {
                                    <li
                                        role="menuitem"
                                        dropdown
                                        triggers="mouseover"
                                        container="body"
                                        class="dropstart"
                                        [placement]="!isReminderMenuDropUp ? 'left top' : 'left bottom'"
                                        [dropup]="isReminderMenuDropUp">
                                        <button
                                            dropdownToggle
                                            class="dropdown-item dropdown-toggle"
                                            type="button"
                                            (click)="$event.stopPropagation()"
                                            translate>
                                            Remind
                                        </button>
                                        <ul *dropdownMenu class="dropdown-menu" role="menu" style="right: 0">
                                            <app-reminder-menu
                                                [isReminderAdded]="!!reply.reminder"
                                                (remindClick)="onRemindClick($event)"
                                                (removeReminderClick)="onRemoveReminderClick()"
                                                (pickDateAndTimeClick)="openReminderModal()"></app-reminder-menu>
                                        </ul>
                                    </li>
                                }
                            </ul>
                        </div>
                    </div>
                }
            </div>

            @if (isSelectable()) {
                <div class="select-button" [class.selected]="reply.isSelected">
                    <sb-inline-svg
                        class="icon"
                        aria-label="My icon"
                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Check icon.svg'">
                    </sb-inline-svg>
                </div>
            }
        </div>

        @if (!reply.editingReply) {
            @for (attachment of reply.contentAttachments; track attachment) {
                <sb-file-view
                    [permalink]="ticket.permalink"
                    [ngClass]="{
                        'mw-100 padding-right-30px': attachment.attachmentType === attachmentTypeEnum.link,
                        'image-attachment': attachment.attachmentType === attachmentTypeEnum.image,
                    }"
                    [isFilePreviewInModal]="true"
                    [attachment]="attachment"
                    [canBeShared]="
                        !commonDataService.isOneTime &&
                        !reply.isDraft &&
                        !commonDataService.user.isReadOnly &&
                        isInboxElementVisible(
                            commonDataService.customerSettings?.inboxElementsVisibility?.ticketHeader?.forwardAction
                        )
                    "
                    (forwardFile)="
                        forwardMessageService.openForwardForm(
                            { message: {}, attachments: [$event] },
                            forwardEntityTypeEnum.attachment,
                            ticket
                        )
                    "
                    [reply]="reply">
                </sb-file-view>
            }
        }

        @if (!reply.editingReply && reply.notContentAttachments && reply.notContentAttachments.length) {
            <div class="attachments-block">
                @for (attachment of reply.notContentAttachments; track attachment; let idx = $index) {
                    <sb-file-preview
                        class="file-container"
                        [attachment]="attachment"
                        [attachments]="reply.notContentAttachments"
                        [fileIndex]="idx"
                        [reply]="reply"
                        [permalink]="ticket.permalink"
                        (forwardFile)="
                            forwardMessageService.openForwardForm(
                                { message: {}, attachments: [$event] },
                                forwardEntityTypeEnum.attachment,
                                ticket
                            )
                        "
                        [canBeShared]="
                            !commonDataService.isOneTime &&
                            !reply.isDraft &&
                            !commonDataService.user.isReadOnly &&
                            isInboxElementVisible(
                                commonDataService.customerSettings?.inboxElementsVisibility?.ticketHeader?.forwardAction
                            )
                        ">
                    </sb-file-preview>
                }
                <div class="clearfix"></div>
            </div>
        }

        <small
            class="reply-controls d-flex align-items-center flex-wrap mt-2"
            [ngClass]="{ transparent: reply.isHidden }">
            @if (
                ticket.isEditable &&
                ticket.constraints.areSubRepliesAllowed &&
                !reply.isDraft &&
                ticket.status !== ticketStatusEnum.completed &&
                !reply.isDeleted &&
                ticket.isTicketCanBeReplied
            ) {
                <span class="mb-1 item-with-dot">
                    <a (click)="showNewSubreplyForm()" translate>Reply</a>
                </span>
            }

            @if (
                reply.isDirectMessageForFbReplyAllowed &&
                ticket.isEditable &&
                !reply.isDeleted &&
                !commonDataService.user.isReadOnly
            ) {
                <span class="mb-1 item-with-dot">
                    @if (reply.privateReplyTicketId) {
                        <a
                            (click)="openTicketInNewWindowService.openTicketInNewTab(reply.privateReplyTicketId)"
                            translate
                            >See response</a
                        >
                    } @else {
                        <a (click)="showPrivateReplyForm(reply)" translate>Message</a>
                    }
                </span>
            }

            @if (ticket.isEditable && ticket.constraints.isReplyLikingAllowed && !reply.isDraft && !reply.isDeleted) {
                <span class="d-flex align-items-center mb-1 item-with-dot">
                    @if (!parent.isFacebook) {
                        <a [hidden]="reply.showLikes" (click)="showLikes()" translate> Like and see likes </a>

                        @if (reply.showLikes) {
                            <a (click)="toggleLike()" class="d-flex align-items-center">
                                <sb-inline-svg
                                    class="icon icon-heart"
                                    [ngClass]="{ 'icon-liked': reply.isLiked }"
                                    [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Heart icon.svg'">
                                </sb-inline-svg>
                                @if (reply.likeCount) {
                                    <span style="padding-left: 3px">{{ reply.likeCount }}</span>
                                }
                            </a>
                        }
                    } @else {
                        @if (!ticket.constraints.areReactionsAllowed) {
                            <a [hidden]="reply.showLikes" (click)="showLikes()" translate> Like and see reactions </a>

                            @if (reply.showLikes) {
                                <a (click)="toggleLike()" class="d-flex align-items-center">
                                    <sb-inline-svg
                                        class="icon icon-heart"
                                        [ngClass]="{ 'icon-liked-facebook': reply.isLiked }"
                                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Thumbs up icon.svg'">
                                    </sb-inline-svg>
                                    @if (reply.likeCount) {
                                        <span class="me-1" style="padding-left: 3px">{{ reply.likeCount }}</span>
                                    }
                                </a>
                            }
                            @if (reply.showLikes && reply.reactions.length) {
                                <app-reactions
                                    [reactions]="reply.reactions"
                                    [isShowTotalCount]="true"
                                    [tooltipTextType]="reactionTooltipTextType.name"
                                    [updateReactionsMarker]="reply.updateReactionsMarker">
                                </app-reactions>
                            }
                        } @else {
                            <a
                                (click)="toggleLike()"
                                [ngClass]="{ 'text-light': !reply.hasReactionFromTeam, 'me-1': reply.reactions.length }"
                                translate>
                                Like
                            </a>
                            @if (reply.reactions.length) {
                                <app-reactions
                                    class="pointer"
                                    (click)="openReactionsWindow.emit({ isTicketReactions: false, replyId: reply.id })"
                                    [reactions]="reply.reactions"
                                    [tooltipTextType]="reactionTooltipTextType.name"
                                    [isShowTotalCount]="true"
                                    [updateReactionsMarker]="reply.updateReactionsMarker">
                                </app-reactions>
                            }
                        }
                    }
                </span>
            }

            @if (reply.permalink) {
                <span class="mb-1 item-with-dot">
                    <a [href]="reply.permalink" target="_blank" translate>Permalink</a>
                </span>
            }

            @if (reply.isDraft) {
                <span class="mb-1 item-with-dot">
                    <span class="label label-warning">
                        <sb-inline-svg
                            class="icon icon-pri icon-sm"
                            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Warning icon v2.svg'">
                        </sb-inline-svg>
                        <span translate>DRAFT</span>
                    </span>
                </span>
            }

            <span
                class="time mb-1 text-light item-with-dot"
                tooltip="{{ reply.creationTime | date: 'dd.MM.yyyy HH:mm' }}"
                container="body"
                >{{ reply.creationTime | timeAgo }}</span
            >

            @if (reply.socialMediaDisplayName) {
                <span class="text-break mb-1 item-with-dot text-light">
                    {{ 'Sent from' | translate }} {{ reply.socialMediaDisplayName }}
                </span>
            }

            @if (reply.tags?.length) {
                <app-tags class="item-with-dot mb-1" [ticketId]="ticket.id" [tags]="reply.tags"> </app-tags>
            }

            @if (reply.msSentiment && reply.msSentiment.value) {
                <app-ms-sentiment
                    class="mb-1 item-with-dot"
                    [sentimentScore]="reply.msSentiment.score"
                    [sentimentValue]="reply.msSentiment.value">
                </app-ms-sentiment>
            }
        </small>

        @if (
            ticket.constraints.maxLevelsCount > 2 &&
            level < ticket.constraints.maxLevelsCount &&
            ticket.isEditable &&
            ticket.isTicketCanBeReplied &&
            ticket.constraints.areSubRepliesAllowed &&
            reply.isShowNewSubreplyForm &&
            !reply.isDeleted
        ) {
            <div
                class="sub-reply full-width new-reply unread-message ticket-message flex-row d-flex mt-2"
                id="new-reply-{{ reply.id }}">
                @if (reply.isSendingReply) {
                    <div class="ticket-blocker"></div>
                }

                <sb-user-avatar
                    class="user-avatar-xs"
                    [size]="'extra-small'"
                    [user]="
                        ticketThreadSocialMediaComponent.isAnsweringFromAnotherPage
                            ? ticketThreadSocialMediaComponent.socialMediaSource
                            : commonDataService.user
                    "
                    [isNeedTooltip]="false">
                </sb-user-avatar>

                <app-new-reply-social-media
                    [ticket]="ticket"
                    [parent]="parent"
                    [newReply]="newReply"
                    [parentReply]="reply">
                </app-new-reply-social-media>
            </div>
        }

        @if (reply.commentsCountForExpander > 0 && !reply.editingReply) {
            <div class="top10 mt-2 print-hidden">
                @if (!reply.areCommentsShown) {
                    <button class="btn btn-notification btn-sm" (click)="showAllSubReplies()">
                        <sb-inline-svg
                            class="icon icon-heart"
                            [url]="'/sb-tools/theme/images/icons/Thin Icon - Conversation.svg'">
                        </sb-inline-svg>
                        <span>
                            {{ reply.commentsCountForExpander }}
                            {{
                                reply.commentsCountForExpander > 1
                                    ? ('more replies' | translate)
                                    : ('more reply' | translate)
                            }}
                        </span>
                    </button>
                }
            </div>
        }
        @if (!threadFilterService.isPrinting) {
            @for (
                subReply of reply.subReplies | lastSubReply: reply : reply.areCommentsShown : reply.subReplies.length;
                track subReply
            ) {
                @if (
                    (!subReply.isRemovedByFilter || subReply.isTransparent) && !(subReply.isDraft && reply.isDeleted)
                ) {
                    <app-reply-social-media
                        class="ticket-message reply sub-reply print-hidden"
                        [ngClass]="{
                            'not-viewed': reply.isViewed === false,
                            'reply-invalid': reply.isInvalid,
                            selected: subReply.isSelected,
                        }"
                        [reply]="subReply"
                        [ticket]="ticket"
                        [isSubReply]="true"
                        [parentReply]="reply"
                        (openReactionsWindow)="
                            openReactionsWindow.emit({ isTicketReactions: false, replyId: subReply.id })
                        "
                        [level]="level + 1">
                    </app-reply-social-media>
                }
            }
        } @else {
            <div style="display: none" class="ticket-thread-for-printing">
                @for (subReply of reply.subReplies; track subReply) {
                    @if (!subReply.isRemovedByFilter || subReply.isTransparent) {
                        <app-reply-social-media
                            class="ticket-message reply sub-reply"
                            [ngClass]="{
                                'not-viewed': reply.isViewed === false,
                                transparent: reply.isHidden || subReply.isHidden,
                                'reply-invalid': reply.isInvalid,
                            }"
                            [reply]="subReply"
                            [ticket]="ticket"
                            [isSubReply]="true"
                            [parentReply]="reply"
                            [level]="level + 1">
                        </app-reply-social-media>
                    }
                }
            </div>
        }
        @if (
            ticket.constraints.maxLevelsCount <= 2 &&
            ticket.isEditable &&
            ticket.isTicketCanBeReplied &&
            ticket.constraints.areSubRepliesAllowed &&
            reply.isShowNewSubreplyForm
        ) {
            <!--todo: check this long list of classes and maybe replace with one special class-->
            <div
                class="full-width new-reply unread-message ticket-message print-hidden flex-row d-flex new-subreply mt-2"
                id="new-reply-{{ reply.id }}">
                @if (reply.isSendingReply) {
                    <div class="ticket-blocker"></div>
                }

                <sb-user-avatar
                    class="user-avatar-xs"
                    [size]="'extra-small'"
                    [user]="
                        ticketThreadSocialMediaComponent.isAnsweringFromAnotherPage
                            ? ticketThreadSocialMediaComponent.socialMediaSource
                            : commonDataService.user
                    "
                    [isNeedTooltip]="false">
                </sb-user-avatar>

                <app-new-reply-social-media
                    [ticket]="ticket"
                    [parent]="parent"
                    [newReply]="newReply"
                    [parentReply]="parentReplyForNewReply">
                </app-new-reply-social-media>
            </div>
        }
    </div>
</div>
